import { handleActions, Action } from "redux-actions";
import { LSID_USERINFO_UPDATE } from "constants/action-types";

interface IState {
    sub?: string;
    givenName?: string;
    familyName?: string;
    email?: string;
    emailVerified?: boolean;
    preferredUsername?: string;
    mfaChallengeTypes?: Array<"email" | "totp" | "recovery_code" | "remember_me_cookie" | "support_generated_otp">;
}

const initialState: IState = {};

export const lsidUserinfo = handleActions(
    {
        [LSID_USERINFO_UPDATE]: (state: IState, action: Action<Partial<IState>>): IState => {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
    initialState,
);
